class DOMSlider extends HTMLElement {
  constructor () {
    super()
    this.sliderContainer = this.querySelector('.product-card-slider__scroll')
    this.sliderItemsContainer = this.querySelector('.product-card-slider__items')
    this.sliderItems = Array.from(this.querySelectorAll('.product-card-slider__item'))
    this.leftArrow = this.querySelector('.product-card-slider__arrows.--left')
    this.rightArrow = this.querySelector('.product-card-slider__arrows.--right')
    this.firstHalfVisibleCard = this.querySelector('.product-card-slider__item.--half-visible')
    this.attachDomEvents()
    this.alignActiveCard()
  }

  connectedCallback () {
    this.updateSliderState()
    window.addEventListener('resize', () => this.updateSliderState())
  }

  updateSliderState () {
    this.cardWidth = this.sliderItems[0].offsetWidth
    this.visibleCardsCount = Math.floor(this.sliderContainer.offsetWidth / this.cardWidth)
    this.totalScrollWidth = this.sliderItems.length * (this.cardWidth + 20)
    this.currentScrollPosition = this.sliderContainer.scrollLeft
    this.updateArrowState()
  }

  updateArrowState () {
    this.updateArrowVisibility()
    const isLeftDisabled = this.currentScrollPosition <= 0
    this.leftArrow.classList.toggle('disabled', isLeftDisabled)
    this.leftArrow.setAttribute('aria-disabled', isLeftDisabled ? 'true' : 'false')

    const maxScrollLeft = Math.max(this.totalScrollWidth - this.sliderContainer.offsetWidth, 0)
    this.rightArrow.classList.toggle('disabled', this.currentScrollPosition > maxScrollLeft)
    this.rightArrow.setAttribute('aria-disabled', this.currentScrollPosition > maxScrollLeft ? 'true' : 'false')
  }

  updateArrowVisibility () {
    const isLeftVisible = this.currentScrollPosition > 0
    const isRightVisible = this.currentScrollPosition < this.totalScrollWidth - this.sliderContainer.offsetWidth

    if (!isLeftVisible && !isRightVisible) {
      this.leftArrow.classList.add('hidden')
      this.rightArrow.classList.add('hidden')
    } else {
      this.leftArrow.classList.remove('hidden')
      this.rightArrow.classList.remove('hidden')
    }
  }

  scrollSlider (direction) {
    const scrollAmount = this.cardWidth * this.visibleCardsCount
    const newScrollPosition = direction === 'right'
      ? this.currentScrollPosition + scrollAmount
      : this.currentScrollPosition - scrollAmount

    this.sliderContainer.scrollTo({
      left: newScrollPosition,
      behavior: 'smooth'
    })
    this.currentScrollPosition = newScrollPosition
    this.updateArrowState()
  }

  attachDomEvents () {
    this.leftArrow.addEventListener('click', () => this.scrollSlider('left'))
    this.rightArrow.addEventListener('click', () => this.scrollSlider('right'))
    this.sliderContainer.addEventListener('scroll', () => {
      this.currentScrollPosition = this.sliderContainer.scrollLeft
      this.updateArrowState()
    })
  }

  alignActiveCard () {
    if (this.firstHalfVisibleCard) {
      const firstNotVisibleCard = this.querySelector('.product-card-slider__item:not(.--half-visible)')
      if (firstNotVisibleCard) {
        const index = Number(firstNotVisibleCard?.dataset?.index || 0)
        if (index === 0) return
        const scrollLeft = firstNotVisibleCard.offsetLeft
        this.sliderContainer.scrollTo({
          left: scrollLeft,
          behavior: 'smooth'
        })
      }
    }
  }
}

customElements.define('dom-slider', DOMSlider)
